import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0014 extends BaseRule {
    name = 'Physio 0014: In-patient physiotherapy services';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0014') return;

        if (autoApply) {
            // In-patient services - applies to physiotherapy services rendered in nursing home or hospital
            // No automatic reduction - this is informational
            line.trace.push('Physio 0014: In-patient physiotherapy services - rendered in nursing home or hospital');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0014',
                message: 'Physiotherapy services rendered to an in-patient in a nursing home or hospital',
                kind: 'overwrite',
                unitsDelta: line.adjustedUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0014') {
                // In-patient services - informational only
                line.trace.push('Physio 0014: In-patient physiotherapy services - rendered in nursing home or hospital');
            }
        });
        return lines;
    }
} 